var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('div',{attrs:{"id":"bar-container"}},[_c('div',{attrs:{"id":"text-container"}},[_c('p',{attrs:{"id":"text"}},[_vm._v(_vm._s(_vm.text))])]),_c('div',{style:({ width: (_vm.percentage + "%") }),attrs:{"id":"bar"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }